import React from "react";
import Link from "next/link";

import styles from "./styles.scss";

import XSMALL_PLACEHOLDER from "public/article/xsmall.jpg";

export type PreviewItem = {
  title: string;
  subtitle?: string;
  imageUrl: string;
  linkHref: string;
  linkAsUrl?: string;
};

export type PreviewStackProps = {
  titleText: string;
  linkText: string;
  linkUrl: string;
  items: PreviewItem[];
  stackStyle?: any;
};

export function PreviewStack(props: PreviewStackProps) {
  return (
    <div className="preview-stack">
      <div className="preview-stack__heading">{props.titleText}</div>
      <div className="preview-stack__stack" style={props.stackStyle}>
        {props.items
          ? props.items.map((item) => {
              return (
                <div key={item.title} className="preview-stack__item">
                  <img data-src={XSMALL_PLACEHOLDER} className="lazyload" />
                  <div className="inner">
                    {item.subtitle ? <div className="subheading">{item.subtitle}</div> : null}
                    <Link href={item.linkHref} legacyBehavior>
                      <a>
                        <div className="heading">{item.title || ""}</div>
                      </a>
                    </Link>
                  </div>
                </div>
              );
            })
          : null}
        <Link href={props.linkUrl} legacyBehavior>
          <a className="preview-stack__more">{props.linkText}</a>
        </Link>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}
